import { render, staticRenderFns } from "./text-area.vue?vue&type=template&id=08a00294&"
import script from "./text-area.vue?vue&type=script&lang=ts&"
export * from "./text-area.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a00294')) {
      api.createRecord('08a00294', component.options)
    } else {
      api.reload('08a00294', component.options)
    }
    module.hot.accept("./text-area.vue?vue&type=template&id=08a00294&", function () {
      api.rerender('08a00294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/text-area.vue"
export default component.exports